/* eslint-disable @typescript-eslint/no-explicit-any */
import { F1, AnyFn } from './types';

export function pipe<I, O1>(f1: F1<I, O1>): F1<I, O1>;
export function pipe<I, O1, O2>(f1: F1<I, O1>, f2: F1<O1, O2>): F1<I, O2>;
export function pipe<I, O1, O2, O3>(
  f1: F1<I, O1>,
  f2: F1<O1, O2>,
  f3: F1<O2, O3>,
): F1<I, O3>;
export function pipe(...fns: Array<AnyFn>) {
  return (input: any) => fns.reduce((acc, f) => f(acc), input);
}

export const filterCollection =
  <T>(fields: Array<keyof T>) =>
  (search: string) =>
  (col: T[]): T[] => {
    if (!search) return col;

    const isExactMatch = search.startsWith('"') && search.endsWith('"');
    const searchTerm = search.toLowerCase().trim();
    const target = isExactMatch ? searchTerm.slice(1, -1) : searchTerm;

    return col.filter((i) => {
      return fields.some((field) => {
        const fieldValue = String(i[field] ?? '').toLowerCase();

        if (isExactMatch) {
          return fieldValue === target.toLowerCase();
        }

        return fieldValue.trim().includes(target.toLowerCase());
      });
    });
  };
